module.exports = __webpack_public_path__ + "img/icon_06.2e3e8519.gif";